<template>
  <div class="reservation-change">
    <div class="form-section-element">
    </div>
    <div class="form-group">
      <label class="col-sm-4 control-label">
        {{ field.label }} <span v-if="field.required" class="required">*</span>
      </label>
      <div class="col-sm-8">
        <select v-bind:name="field.name" class="form-control"
          v-model="field.value">
          <option value="" disabled>
            Select a {{ field.singleLabel ? field.singleLabel : field.label }}
          </option>
          <option v-for="object in field.objects" v-bind:value="object.uuid">
            {{ object[field.objectName] }}
          </option>
        </select>
        <span class="form-validation-error"
          v-show="!field.valid && field.dirty">
          Please select a
           {{ field.singleLabel ? field.singleLabel : field.label }}.
         </span>
        <span class="green fa fa-check form-control-feedback
          form-control-feedback-success form-control-feedback-select"
            v-show="field.valid && field.dirty"></span>
        <span class="green fa fa-remove form-control-feedback
          form-control-feedback-error form-control-feedback-select"
            v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
    <div class="col-lg-12">
      <div v-if="cars.length > 0">
        <h4 class="car-item-header">Available Replacement Cars</h4>
        <p class="alert alert-info">
          Should you choose to accept a replacement vehicle, your account will
          be credited one hour at the original reservation's hourly rate.
        </p>
      </div>
      <div v-if="noCars">
        <p class="alert alert-warning">
          Sorry, there are no replacement cars available for your selected
          reservation.
          <br/>
          You can choose to either wait for the car to return or request to cancel your booking.
          <br/><br/>
          <button class="btn btn-default" type="submit">Cancel Booking</button>
        </p>
      </div>
      <input type="hidden" name="selectedCar" v-model="selectedCar.uuid">
      <input type="hidden" name="extraCredit" v-model="object.extraCredit">
      <template v-for="car in cars">
        <div class="row">
          <div class="col-md-4 col-sm-4 col-xs-12">
            <p><h4 class="car-type">{{ car.car.CarType.name }}</h4>
            {{ car.car.name }} (#{{ car.car.convadisId }} - {{ car.car.rego }})
            <br/>
            <img class="img-thumbnail"
              v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+
                ( car.car.CarType.AmazonImage.objectKey ?
                    car.car.CarType.AmazonImage.objectKey : 'spacer.gif' ) +
                      '?v=' + new Date().getTime()"/>
          </div>
          <div class="col-md-5 col-sm-4 col-xs-12">
            <br/>
            <p>
              <h5><i class="fa fa-map-marker fa-2x"></i> Address</h5><br/>
              {{ car.car.Lot.address }}<br/>
            </p>
            <p><strong>Location Details</strong><br/>
              {{ car.car.Lot.addressMemo }} </p>
            <p>
              <a v-bind:href="'https://www.google.com/maps?q='+
                car.car.Lot.latitude +','+ car.car.Lot.longitude"
                  target="_blank" class="btn btn-default btn-sm">
                  View on Google Maps
                </a>
            </p>
          </div>
          <div class="col-md-3 col-sm-4 col-xs-12">
            <br/>
            <h5>Rates</h5><br/>
            <label :class="randomLabel">{{ car.car.CarType.CarClass.name }}</label>
            <br/><br/>
            <div class="small-price-block"
              v-bind:class="{
                'red': parseFloat(object.reservation.hourlyRate) <
                  parseFloat(car.rate.hourlyRate),
                    'green': parseFloat(object.reservation.hourlyRate) >
                      parseFloat(car.rate.hourlyRate) }">
              <span class="small-price-block-dollar">$</span>
              <span class="small-price-block-price">
                {{ car.rate.hourlyRate }}
              </span>
              <span class="small-price-block-per">/hr</span>
            </div>
            <div class="small-price-block"
              v-bind:class="{
                'red': parseFloat(object.reservation.dailyRate) <
                  parseFloat(car.rate.dailyRate),
                    'green': parseFloat(object.reservation.dailyRate) >
                      parseFloat(car.rate.dailyRate) }">
              <span class="small-price-block-dollar">$</span>
              <span class="small-price-block-price">
                {{ car.rate.dailyRate }}
              </span>
              <span class="small-price-block-per">/day</span>
            </div>
            <br/>
            <a v-on:click="chooseCar(car)" v-show="!change"
              class="btn btn-default">Choose <i class="fa fa-check"></i></a>
            <a v-on:click="search(reservation, 'change')" v-show="change"
              class="btn btn-default">Change <i class="fa fa-refresh"></i></a>
          </div>
        </div>
        <hr/>
      </template>
      <div v-show="change">
        <h4 class="car-item-header">Extend Booking</h4>
        <p class="text-right">
          <strong>Booking start time:</strong> {{ startDate }}<br/>
          <strong>Booking end time:</strong> {{ endDate }}
        </p>

        <div class="row">
          <div class="col-md-12">
            <date-time-input v-bind:field.sync="extendTime"></date-time-input>
            <div v-if="!carAvailable" class="callout callout-danger">
              The time you have selected is not available for this car, there
              are conflicting reservations:
              <template v-for="reservation in conflictingReservations">
                <p><strong>{{ reservation.startDate | date_format reservation.Lot.timezone }} -
                  {{ reservation.endDate | date_format reservation.Lot.timezone }}</strong></p>
              </template>
            </div>
            <div v-else>
              <p class="text-right">
                <strong>New booking end time:</strong> {{ newEndDate }}
              </p>
            </div>
          </div>
        </div>
        <price-breakdown :object.sync="object"></price-breakdown>
      </div>
    </div>
  </div>
</template>

<script>
import CarItem from '../displays/CarItem.vue'
import DateTimeInput from '../inputs/DateTimeInput.vue'
import moment from 'moment-timezone'
import PriceBreakdown from '../displays/PriceBreakdown.vue'

export default {
  name: 'ReservationChange',
  components: {
    CarItem,
    DateTimeInput,
    PriceBreakdown
  },
  props: {
    field: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'objectSelect',
          objectName: 'name',
          value: '',
          objects: []
        }
      }
    }
  },
  data () {
    return {
      fieldLength: 0,
      selectedCar: {},
      cars: [],
      noCars: false,
      change: false,
      carAvailable: true,
      object: {
        carUuid: '',
        cost: {},
        cards: {},
        extras: [],
        rate: {},
        reservation: {},
        extraCredit: 0
      },
      conflictingReservations: [],
      extendTime: {
        label: 'Change end time',
        name: 'newEndTime',
        value: '',
        required: true,
        minDate: '',
        maxDate: '',
        valid: true,
        dirty: true
      }
    }
  },
  computed: {
    startDate: function () {
      return moment(this.object.cost.startTime).format('LLLL')
    },
    endDate: function () {
      return moment(this.object.reservation.endDate).format('LLLL')
    },
    newEndDate: function () {
      return moment(this.extendTime.value).format('LLLL')
    },
    randomLabel () {
      if (this.car.car.CarType.CarClass.name) {
        let num = this.car.car.CarType.CarClass.name.charCodeAt(0)
        return {
          'label-success': num % 5 === 0,
          'label-primary': num % 5 === 1,
          'label-danger': num % 5 === 2,
          'label-info': num % 5 === 3,
          'label-warning': num % 5 === 4
        }
      } else {
        return {}
      }
    }
  },
  methods: {
    search (object, source) {
      this.field.valid = false
      this.change = false
      if (source !== 'change') {
        this.object.reservation = this.field.objects.find((el, i, arr) => {
          return el.uuid === object
        })
      }
      let startDate = moment(this.object.reservation.startDate).valueOf()
      let endDate = moment(this.object.reservation.endDate).valueOf()
      let carUuid = this.object.reservation.CarUuid
      let authType = this.$route.authType
      this.$http.get(`${authType}/reservation-change/search`,
        {
          params: {
            startDate,
            endDate,
            carUuid
          }
        })
        .then((response, status, request) => {
          this.cars = response.data.results
          if (this.cars.length === 0) {
            this.noCars = true
            this.$parent.form.submit = null
          }
        })
    },
    chooseCar (newCar) {
      this.field.valid = true
      this.cars = [newCar]
      this.selectedCar = newCar.car
      this.extendTime.value = this.object.reservation.endDate
      this.extendTime.minDate =
        moment(this.object.reservation.endDate).subtract(1, 'm')
      this.extendTime.maxDate =
        moment(this.object.reservation.startDate).add(3, 'months')
      this.change = true
      this.object.extraCredit = this.object.reservation.hourlyRate
      this.updateCost(this.object.reservation.endDate)
    },
    checkAvailability (endDate) {
      let endTime = moment(endDate).valueOf()
      let startTime = moment(this.object.reservation.startDate).valueOf()
      let authType = this.$route.authType
      let carUuid = this.selectedCar.uuid
      this.$http.get(`${authType}/reservation-change/check-availability`, {
        params: { startTime, endTime, carUuid }
      }).then((response, status, request) => {
        if (response.data.car.Reservations.length !== 0) {
          this.carAvailable = false
          this.extendTime.valid = false
          this.conflictingReservations = response.data.car.Reservations
        }
        if (this.extendTime.valid) this.updateCost(endDate)
      })
    },
    updateCost (end) {
      let carUuid = this.selectedCar.uuid
      let startDate = this.object.reservation.startDate
      let endDate = end
      let authType = this.$route.authType
      let extras = this.object.reservation.extras
      let extraCredit = this.object.extraCredit
      let alreadyPaid = this.object.reservation.quotedCost
      this.$http.post(`${authType}/update-cost`, {
        carUuid,
        startDate,
        endDate,
        extras,
        extraCredit,
        alreadyPaid
      }).then((response, status, request) => {
        this.object.cost = response.data.cost
        this.object.rate = response.data.rate.rate
        this.object.extras = response.data.rate.extras
        this.object.carUuid = carUuid
      })
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.search(newVal)
    },
    'extendTime.value': function (newVal, oldVal) {
      if (moment(newVal).format() !== 'Invalid date') {
        this.checkAvailability(newVal)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ReservationChange.vue?137f40e2